import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { MozApp } from '../../models/App';
import { mozAppsEvents } from '../../../lib/constants';

const InstallCommand = Command.extend({
  detail: {
    isHosted: Boolean,
    manifestURL: String,
    jwt: [Object]
  }
}).defaultTo(
  generateDefault({
    action: commandList.INSTALL_APP
  })
);

const UninstallCommand = Command.extend({
  detail: {
    manifestURL: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.UNINSTALL_APP
  })
);

const CancelDownloadCommand = Command.extend({
  detail: {
    manifestURL: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.CANCEL_DOWNLOAD
  })
);

const LaunchAppCommand = Command.extend({
  detail: {
    manifestURL: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.LAUNCH_APP
  })
);

const UpdateAppCommand = Command.extend({
  detail: {
    manifestURL: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.UPDATE_APP
  })
);

const CheckAppUpdateCommand = Command.extend({
  detail: {
    manifestURL: String,
    autoDownload: [Boolean]
  }
}).defaultTo(
  generateDefault({
    action: commandList.CHECK_APP_UPDATE
  })
);

const MozAppUpdateCommand = Command.extend({
  detail: {
    manifestURL: String,
    mozAppsEvent: Object.values(mozAppsEvents),
    mozAppEvent: [String],
    mozApp: MozApp
  }
}).defaultTo(
  generateDefault({
    action: commandList.MOZAPP_UPDATE
  })
);

export {
  InstallCommand,
  UninstallCommand,
  CancelDownloadCommand,
  LaunchAppCommand,
  UpdateAppCommand,
  MozAppUpdateCommand,
  CheckAppUpdateCommand
};
